// Productpagina (/product/:id) : galerij, koopblok, upsell, accessoires,
// herinnering en technische fiche. Vertaling van fr/fiche.js — zelfde sleutels.
// De PRODUCTteksten (name, tagline, description, features) komen uit de
// database via de API : die lopen via tp()/tpList(), nooit via deze sleutels.
export default {
  'fiche.seo.titre': '{nom} — Joyful Reveal',
  'fiche.seo.descriptionDefaut':
    'Het gender reveal-spel Joyful Reveal: een quiz in twee teams, een puzzel om samen te leggen en een laatste stukje om te krassen.',
  'fiche.seo.titreIntrouvable': 'Product niet gevonden',
  'fiche.seo.titreErreur': 'Fout bij het laden',
  'fiche.seo.descriptionErreur': 'Dit product is niet meer beschikbaar in de shop van Mirum Games.',

  'fiche.chargement.produit': 'Product wordt geladen…',

  'fiche.erreur.introuvableTitre': 'Dit pack bestaat niet meer',
  'fiche.erreur.erreurTitre': 'Laden mislukt',
  'fiche.erreur.introuvableTexte':
    'Misschien is het vervangen. U vindt al onze packs terug in de shop.',
  'fiche.erreur.erreurTexte':
    'De verbinding met de server is mislukt. Probeer het zo meteen opnieuw.',
  'fiche.erreur.versBoutique': '🛍️ Naar de shop',

  'fiche.ariane.label': 'Kruimelpad',

  'fiche.visuels.boiteAlt':
    'Voorkant van de Joyful Reveal-doos: twee beertjes en het puzzelstukje om te krassen',
  'fiche.visuels.boiteLegende': 'De doos',
  'fiche.visuels.dosAlt':
    'Achterkant van de doos: de 4 stappen van het spel, de talen van de spelregels en de QR-code',
  'fiche.visuels.dosLegende': 'De achterkant van de doos',
  'fiche.visuels.contenuAlt':
    'Inhoud van het Pack Premium: de doos, de vragenlijst en de twee katoenen zakjes',
  'fiche.visuels.contenuLegende': 'Wat u ontvangt',
  'fiche.visuels.pochonsAlt': 'De twee katoenen zakjes voor de twee teams',
  'fiche.visuels.pochonsLegende': 'De teamzakjes',
  'fiche.visuels.grattageAlt': 'Een hand krast met een muntstuk het gouden vakje van de puzzel weg: het woord GIRL verschijnt',
  'fiche.visuels.grattageLegende': 'Het krassen',
  'fiche.visuels.puzzleEncadreAlt':
    'De gelegde puzzel in een gouden lijst, op een piano tussen twee kandelaars',
  'fiche.visuels.puzzleEncadreLegende': 'Het ingelijste aandenken',
  'fiche.visuels.puzzleTableAlt':
    'De gelegde puzzel in zijn gouden lijst, op een eiken tafel',
  'fiche.visuels.puzzleTableLegende': 'Na het feest',
  'fiche.visuels.questionnaireAlt':
    'De op karton gedrukte vragenlijst, met de kolommen Team 1, Team 2 en Ouders',
  'fiche.visuels.questionnaireLegende': 'De gedrukte vragenlijst',
  'fiche.visuels.voir': 'Bekijken: {legende}',

  'fiche.achat.gamme': 'Joyful Reveal — Beertjes',
  'fiche.achat.promesse':
    'Elf vragen, twee teams, één krasstukje — en iedereen ontdekt het tegelijk.',
  'fiche.achat.remise': '−{n} %',
  'fiche.achat.contenuTitre': 'Wat zit er in dit pack',
  'fiche.achat.ajouter': '🛒 In het winkelmandje',
  'fiche.achat.indisponible': 'Tijdelijk niet beschikbaar',
  'fiche.achat.reappro': 'Nieuwe voorraad onderweg',
  'fiche.achat.expedition': '📦 Verzonden vanuit België binnen 1 tot 2 werkdagen',
  // Moet gelijk blijven met PAYS_LIVRES (frontend/src/lib/zonesLivraison.js).
  'fiche.achat.livraison':
    '🚚 Levering in België, Frankrijk, Luxemburg, Nederland, Duitsland en Spanje — verzendkosten berekend bij de betaling',
  'fiche.achat.langue':
    '🇫🇷 Doos en spelregels in het Frans (tweetalige samenvatting Frans / Engels op de doos)',
  'fiche.achat.retour': '↩️ 14 dagen bedenktijd',

  'fiche.genre.titre': 'Het is voor…',
  'fiche.genre.fille': 'Meisje',
  'fiche.genre.garcon': 'Jongen',
  'fiche.genre.mixte': 'Meisje + Jongen',
  'fiche.genre.alerte': 'Kies eerst meisje of jongen.',
  'fiche.genre.discretion':
    'Niemand anders dan u weet het: het kraslootje verklapt het op het feest.',
  'fiche.genre.packMixte': '👫 Dit pack bevat zowel de meisjes- als de jongensversie',
  'fiche.genre.packGarcon': '👦 Jongensversie',
  'fiche.genre.packFille': '👧 Meisjesversie',

  // Zin in 4 stukken, want twee passages staan vet in de JSX:
  // « Voor [X extra] krijgt u met het [NAAM] alle accessoires die … »
  'fiche.upsell.badge': '⭐ Het vaakst gekozen',
  'fiche.upsell.phraseAvant': 'Voor',
  'fiche.upsell.phraseGras': '{prix} extra',
  'fiche.upsell.phraseMilieu': ' krijgt u met het',
  'fiche.upsell.phraseApres': 'alle accessoires die het feest compleet maken.',
  'fiche.upsell.voir': 'Bekijk het {nom} →',

  'fiche.caracteristiques.joueursLabel': 'Spelers',
  'fiche.caracteristiques.joueursValeur': '2 tot 10',
  'fiche.caracteristiques.dureeLabel': 'Duur',
  'fiche.caracteristiques.dureeValeur': '≈ 20 minuten',
  'fiche.caracteristiques.piecesLabel': 'Stukjes',
  'fiche.caracteristiques.piecesValeur': '11 + 1 om te krassen',
  'fiche.caracteristiques.ageLabel': 'Leeftijd',
  'fiche.caracteristiques.ageValeur': 'Vanaf 3 jaar',

  'fiche.etapes.reglesLien': 'Lees de volledige spelregels',
  'fiche.etapes.reglesSuite': '— de 11 vragen zijn meegeleverd, klaar om af te drukken.',

  'fiche.accessoires.titreAvec': '🎁 Alles zit al klaar in dit pack',
  'fiche.accessoires.titreSans': '🎁 Zin om alles klaar te vinden zodra de doos opengaat?',
  'fiche.accessoires.introAvec':
    'U opent de doos, u legt de vragenlijst op tafel, iedereen neemt zijn zakje — en het spel begint.',
  'fiche.accessoires.introSans':
    'Het Pack Premium voegt de drie accessoires toe die op de grote dag het verschil maken:',
  'fiche.accessoires.photoContenuAlt':
    'De inhoud van het Pack Premium plat uitgelegd: de doos, de gedrukte vragenlijst en de twee katoenen teamzakjes',
  'fiche.accessoires.photoContenuLegende':
    'De gedrukte vragenlijst, de doos en de zakjes — echte foto',
  'fiche.accessoires.photoPochonsAlt':
    'De twee katoenen zakjes met trekkoord, met etiket Team 1 en Team 2',
  'fiche.accessoires.photoPochonsLegende': 'De katoenen teamzakjes — echte foto',
  'fiche.accessoires.pochonsTitre': 'Twee katoenen zakjes',
  'fiche.accessoires.pochonsTexte':
    'Met etiket Team 1 en Team 2: iedereen kiest bij aankomst zijn kamp, en het spel start vanzelf.',
  'fiche.accessoires.questionnaireTitre': 'De vragenlijst, al gedrukt',
  'fiche.accessoires.questionnaireTexte':
    'De 11 vragen op karton van 400 g, met de scorekolommen van beide teams — en een blanco sjabloon voor uw eigen vragen.',
  'fiche.accessoires.enveloppeTitre': 'De herinneringsenvelop',
  'fiche.accessoires.enveloppeTexte':
    'Na het feest schuift de ingevulde vragenlijst erin — de envelop is gemaakt om achteraan een fotolijst te bevestigen.',
  'fiche.accessoires.decouvrir': 'Ontdek het {nom} →',

  'fiche.souvenir.photoAlt':
    'De afgewerkte puzzel, ingelijst en opgehangen aan de muur van een babykamer',
  'fiche.souvenir.photoLegende':
    'De puzzel van de grote dag — 14 × 21 cm, het formaat van een fotolijst',
  'fiche.souvenir.surtitre': 'En na het feest?',
  'fiche.souvenir.titre': 'Er blijft een herinnering aan de muur',
  // Zin doorgeknipt rond het vette « 14 × 21 cm » (de maat wordt niet vertaald).
  'fiche.souvenir.tailleAvant': 'De afgewerkte puzzel meet',
  'fiche.souvenir.tailleApres':
    '— precies het formaat van een fotolijst uit de winkel. Veel ouders lijsten hem in en hangen hem in de babykamer: de dag waarop iedereen het nieuws hoorde, in één beeld.',
  // Zin doorgeknipt rond het vette « de herinneringsenvelop ».
  'fiche.souvenir.premiumAvant':
    'De vragenlijst van dit pack is daarvoor gemaakt: het winnende team, wie het stukje heeft gekrast, de datum — eenmaal ingevuld schuift u hem in',
  'fiche.souvenir.premiumEnveloppe': 'de herinneringsenvelop',
  'fiche.souvenir.premiumApres':
    ', die achteraan de fotolijst wordt bevestigd. Over tien jaar maakt u hem samen weer open.',
  'fiche.souvenir.upsell':
    'Met het Pack Premium schuift u de vragenlijst die u op de grote dag invulde (winnend team, wie er gekrast heeft, de datum) in de herinneringsenvelop, achteraan de fotolijst. Over tien jaar maakt u hem samen weer open.',

  'fiche.specs.titre': '📋 Technische fiche',
  'fiche.specs.contenuLabel': 'Inhoud van de doos',
  'fiche.specs.contenuValeur': '11 puzzelstukjes om te winnen + 1 uniek stukje om te krassen',
  'fiche.specs.principeLabel': 'Principe',
  'fiche.specs.principeValeur':
    'Quiz in twee teams, puzzel om te leggen, onthulling door te krassen op het einde',
  'fiche.specs.reglesLabel': 'Spelregels',
  'fiche.specs.reglesValeur':
    'Samengevat op de achterkant van de doos, volledige versie online via de QR-code',
  'fiche.specs.matiereLabel': 'Materiaal',
  'fiche.specs.matiereValeur': 'Karton — doos en stukjes',
  'fiche.specs.puzzleLabel': 'Gelegde puzzel',
  'fiche.specs.puzzleValeur': '14 × 21 cm — het formaat van een fotolijst uit de winkel',
  'fiche.specs.securiteLabel': 'Veiligheid',
  'fiche.specs.securiteValeur':
    'Conform CE / EN 71. Kleine onderdelen: niet geschikt voor kinderen jonger dan 3 jaar',
  'fiche.specs.origineLabel': 'Herkomst',
  'fiche.specs.origineValeur': 'Ontworpen en verzonden vanuit België door Mirum Games',
};
